<div class="not-found-box">
  <div class="container not-found-box__wrapper">
    <img class="not-found-box__image" [src]="imageUrl" [alt]="alt" />
    <h1 class="not-found-box__title">{{ errorCode }}</h1>
    <h2 class="not-found-box__subtitle">{{ title }}</h2>
    <div class="not-found-box__description" [innerHTML]="description"></div>
    <hdi-button
      *ngIf="linkLabel && linkUrl"
      class="not-found-box__button"
      [type]="ButtonType.PRIMARY_ICON"
      [label]="linkLabel | capitalize"
      [iconName]="'arrow-right-long'"
      [href]="linkUrl"
    ></hdi-button>
  </div>
  <picture *ngIf="errorCode === '404'" class="not-found-box__overlay">
    <source
      media="(min-width: 560px)"
      [srcset]="'./assets/images/pw_404-error_bg_desktop.svg'"
    />
    <img [src]="'./assets/images/pw_404-error_bg_mobile.svg'" alt="" />
  </picture>
  <picture *ngIf="errorCode === '500'" class="not-found-box__overlay">
    <source
      media="(min-width: 560px)"
      [srcset]="'./assets/images/pw_500-error_bg_desktop.svg'"
    />
    <img [src]="'./assets/images/pw_500-error_bg_mobile.svg'" alt="" />
  </picture>
</div>
